import React, { Component } from "react";
// Translations
import { withTranslation } from "react-i18next";
// Components
import Select from "../Input/select";

class Save extends Component {

    render() {
        const { t, billing, updateElement, countries, updateCountry, province, updateProvince } = this.props;
        return (
            <React.Fragment>
               <div className="man-module">
                    <input id={"firstname_input_billing"} placeholder={t("input.firstname_placeholder")} maxLength="50" name="name" value={billing.name} onChange={(e) => updateElement(e, "name")} type="text" />
                    <input id={"lastname_input_billing"} placeholder={t("input.lastname_placeholder")} maxLength="50" name="lastname" value={billing.lastname} onChange={(e) => updateElement(e, "lastname")} type="text" />
                    <input id={"dni_input_billing"} placeholder={t("inputs:input.dni_placeholder")} maxLength="20" name="dni" value={billing.dni} onChange={(e) => updateElement(e, "dni")} type="text" />
                    <input id={"email_input_billing"} autoComplete="nope" placeholder={t("input.email_placeholder")} name="email" value={billing.email} onChange={(e) => updateElement(e, "email")} type="email" />
                    <input id={"phone_input_billing"} type="text" placeholder={t("input.phone_placeholder")} name="phone" value={billing.phone} onChange={(e) => updateElement(e, "phone")} />
                </div>
                <div className="man-module">
                    <input id={"nif_input_billing"} placeholder={t("input.cif_nif_placeholder")} name="cif_nif" value={billing.cif_nif} onChange={(e) => updateElement(e, "cif_nif")} type="text" />
                    <input id={"company_input_billing"} placeholder={t("input.company_placeholder")} maxLength="50" name="company" value={billing.company} onChange={(e) => updateElement(e, "company")} type="text" />
                    <div></div>
                </div>
                <div className="man-module">
                    <input id={"address_input_billing"} placeholder={t("input.address_placeholder")} maxLength="100" name="address" value={billing.address} onChange={(e) => updateElement(e, "address")} type="text" />
                    <input id={"floor_input_billing"} placeholder={t("input.floor_placeholder")} maxLength="20" name="floor" value={billing.floor} onChange={(e) => updateElement(e, "floor")} type="number" />
                    <input id={"door_input_billing"} placeholder={t("input.door_placeholder")} maxLength="20" name="door" value={billing.door} onChange={(e) => updateElement(e, "door")} type="number" />
                </div>
                <div className="man-module">
                    <input id={"city_input_billing"} placeholder={t("input.city_placeholder")} name="city" value={billing.city} onChange={(e) => updateElement(e, "city")} type="text" />
                    <input id={"postal_code_input_billing"} placeholder={t("input.postal_code_placeholder")} maxLength="20" name="postal_code" value={billing.postal_code} onChange={(e) => updateElement(e, "postal_code")} type="number" />
                </div>
                <div className="man-module">
                    <Select
                        strSelected={billing.country}
                        array={countries}
                        onSelect={updateCountry}
                        placeholder={t("input.country_placeholder")}
                        value={"country"}
                        id={"select-billing-country"}
                        t={t}
                    />
                    {
                        billing.country === "Spain" &&
                        <Select
                            strSelected={billing.province}
                            array={province}
                            onSelect={updateProvince}
                            placeholder={t("input.province_placeholder")}
                            value={"province"}
                            id={"select-billing-province"}
                            t={t}
                        />
                    }
                    <div></div>
                </div>
            </React.Fragment>
        );
    }
}

export default withTranslation("inputs")(Save);